export const USER_LOCALSTORAGE_KEY = 'user'

export const USER_SUCCESS_KEY = 'user_success';
export const SHOW_INSTALL_BUTTON = 'showInstallButton';
